<template>
<w-settings-summary ref="settingsSummary" :menu="menu" @change="onChangeMenu">
  <component slot="activeView" :is="activeView" :title="activeMenu.name"></component>
</w-settings-summary>
</template>

<script>
import WSettingsSummary from '@/components/template/SettingsSummary';
import WConfigSettings from './ConfigSettings';
import WWarningSettings from './WarningSettings';

export default {
  name: 'WApmSettings',
  components: {
    WSettingsSummary,
    WConfigSettings,
    WWarningSettings,
  },
  data() {
    return {
      activeMenu: {},
      activeView: null,
      menu: [
        {
          id: 'configSettings',
          name: '구성 관리',
          desc: ['APM내 계층 구조를 설정합니다.'],
          data: null,
          orderbyIndex: 1,
        },
        {
          id: 'warningSettings',
          name: '경보',
          desc: ['특정 속성의 예외가 발생하게 되면 해당 예외는 경보로 구분합니다. 경보의 이벤트 레벨, 임계치, 기준 횟수 등을 설정합니다.'],
          data: null,
          orderbyIndex: 2,
        },
      ],
    };
  },
  methods: {
    onChangeMenu(activeView, activeMenu) {
      this.activeView = activeView;
      this.activeMenu = activeMenu;
    },
    clearActiveView() {
      this.$refs.settingsSummary.clearActiveView();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/index.vue